import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import PageTitle from "../../../components/Accessibility/PageTitle";
import LoadingApp from "../../../components/LoadingApp";
import ModalConfirmData from "../../../components/ModalConfirmData";
import ModalFeedBack from "../../../components/ModalFeedBack";
import { TermoResponsabilidade } from "../../../interfaces/entities/TermoResponsabilidade";
import { StepAeromedicaEnum } from "../../../interfaces/enum/StepAeromedicaEnum";
import {
  aceitarAdesaoAeromedica,
  aceiteAdesaoAeromedica,
  getContratoAeromedica,
  termosAdesaoAeromedica
} from "../../../services/Beneficios/Aeromedica";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { getBenef } from "../../../Store/storages/BeneficiarioStorage";
import { sxLabel } from "../../SaudeOnline/AtestadoMedicoDigital/sxProps";
import Banner from "./Banner";
import ContractAeromedica from "./ContractAeromedica";
import "./styles.css";
import { sxRefundButton, sxRefundButtonText } from "./sxProps";
import TermsAeromedica from "./TermsAeromedica";
import { useNavigate } from "react-router-dom";

interface MenuItem {
  title: string;
  action: string;
  descricao?: string;
}

const Aeromedica = () => {

  const accessibility = useAccessibility();
  const benef = getBenef();

  const [menu, setMenu] = useState<MenuItem[]>([]);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [justView, setJustView] = useState<boolean>(false);
  const [showTerms, setShowTerms] = useState<boolean>(false);
  const [showContract, setShowContract] = useState<boolean>(false);
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const [acceptedContract, setAcceptedContract] = useState(false);
  const [banner, setBanner] = useState<string | null>(null);
  const [stepAdesaoAeromedica, setStepAdesaoAeromedica] = useState<StepAeromedicaEnum | 0>(0);
  const [textLoading, setTextLoading] = useState("Carregando...");
  const [contract, setContract] = useState<TermoResponsabilidade | null>(null);
  const [termo, setTermo] = useState<TermoResponsabilidade | null>(null);
  const [showEmailModal, setShowEmailModal] = useState<boolean>(false);
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const navigate = useNavigate();

  async function fetchAccepted() {
    setShowLoading(true);
    const aceite = await aceiteAdesaoAeromedica();
    if (aceite?.data?.termoAeroMedica?.indAceite === "S") {
      setMenu(aceite.data.menu || []);
      setAcceptedTerms(true);
      setAcceptedContract(true);
      setJustView(true);
      setShowMenu(true);
    } else {
      setStepAdesaoAeromedica(StepAeromedicaEnum.Banner);
      const imagemBanner = aceite?.data?.banner?.imagens?.[0];
      if (imagemBanner) {
        setBanner(imagemBanner);
      }
    }
    setShowLoading(false);
  }

  useEffect(() => {
    fetchAccepted();
  }, []);

  const fetchTermo = async () => {
    setShowLoading(true);
    setTextLoading("Carregando termo...");
    try {
      const response = await termosAdesaoAeromedica();
      setTermo(response?.data);
    } catch (error) {
      console.error("Erro ao carregar termo:", error);
      setModalFeedback({
        icon: 'error',
        title: 'Erro',
        subTitle: 'Não foi possível carregar o termo. Tente novamente mais tarde.',
        closeAction: () => setModalFeedback(null),
        showButtonModal: true,
        textButton: 'OK',
        buttonAction: () => setModalFeedback(null)
      });
    } finally {
      setShowLoading(false);
    }
  };

  const fetchContrato = async () => {
    setShowLoading(true);
    setTextLoading("Carregando contrato...");
    try {
      const response = await getContratoAeromedica();
      setContract(response?.data || null);
    } catch (error) {
      console.error("Erro ao carregar contrato:", error);
      setModalFeedback({
        icon: 'error',
        title: 'Erro',
        subTitle: 'Não foi possível carregar o contrato. Tente novamente mais tarde.',
        closeAction: () => setModalFeedback(null),
        showButtonModal: true,
        textButton: 'OK',
        buttonAction: () => setModalFeedback(null)
      });
    } finally {
      setShowLoading(false);
    }
  };

  const handleBack = () => {
    setStepAdesaoAeromedica((prev) => {
      if (prev === StepAeromedicaEnum.Termos) {
        return StepAeromedicaEnum.Banner;
      } else if (prev === StepAeromedicaEnum.Contrato) {
        return StepAeromedicaEnum.Termos;
      }
      return prev;
    });
  };

  const handleShowEmailModal = () => {
    setShowEmailModal((prev) => !prev);
  };

  const handleShowTerms = () => {
    setShowTerms((prev) => !prev);
    setShowMenu((prev) => !prev);
  };

  const handleShowContract = () => {
    setShowContract((prev) => !prev);
    setShowMenu((prev) => !prev);
  };

  const handleMenuClick = (item: MenuItem) => {
    switch (item.action) {
      case 'GetTermoAeromedica':
        !termo && fetchTermo();
        handleShowTerms();
        break;
      case 'GetContratoAeromedica':
        !contract && fetchContrato();
        handleShowContract();
        break;
      case null:
        setModalFeedback({
          icon: 'warning',
          title: 'Solicitar cancelamento',
          subTitle: item.descricao,
          closeAction: () => setModalFeedback(null),
          showButtonModal: true,
          textButton: 'OK',
          buttonAction: () => setModalFeedback(null)
        });
        break;
    }
  };

  const handleContinue = () => {
    if (stepAdesaoAeromedica === StepAeromedicaEnum.Banner) {
      if (benef?.tipoUsr === "DEPEND") {
        setModalFeedback({
          icon: 'error',
          title: 'Acesso não permitido',
          subTitle: 'A contratação do serviço aeromédica é restrita ao titular do plano. Para mais informações nos contatar pelo e-mail retencaopf@unimedcampinas.com.br',
          closeAction: () => setModalFeedback(null),
          showButtonModal: true,
          textButton: 'OK',
          buttonAction: () => setModalFeedback(null)
        });
        return;
      }
      setStepAdesaoAeromedica(StepAeromedicaEnum.Termos);
    } else if (stepAdesaoAeromedica === StepAeromedicaEnum.Termos) {
      setStepAdesaoAeromedica(StepAeromedicaEnum.Contrato);
    } else if (stepAdesaoAeromedica === StepAeromedicaEnum.Contrato) {
      handleShowEmailModal();
    }
  };

  const handleConfirmUserData = (email: string, celular: string) => {
    setShowEmailModal(false);
    setShowLoading(true);

    const aceiteAdesaoAeromedicaData = {
      email,
      cel: celular,
      idTermo: Number(termo?.idTermo) || 0,
      idContrato: Number(contract?.idContrato) || 0,
      indAceiteContrato: 'S',
      indAceiteTermo: 'S',
      idOperador: Number(benef?.idOperador) || 0,
      tipoUsr: benef?.tipoUsr || null
    };

    aceitarAdesaoAeromedica(aceiteAdesaoAeromedicaData)
      .then((response) => {
        setAcceptedTerms(true);
        setStepAdesaoAeromedica(StepAeromedicaEnum.Termos);
        setModalFeedback({
          icon: 'success',
          title: 'Solicitação registrada',
          subTitle: 'Sua solicitação foi registrada, em breve você receberá a confirmação da sua adesão.',
          closeAction: () => {
            setModalFeedback(null);
            navigate('/home')
          },
          showButtonModal: true,
          textButton: 'OK, ENTENDI',
          buttonAction: () => {
            setModalFeedback(null);
            navigate('/home')
          }
        });
      })
      .catch((error) => {
        console.error("Erro ao aceitar termo de adesão:", error);
        const errorMessage = error.response.data.mensagem
        setModalFeedback({
          icon: 'error',
          title: 'Erro',
          subTitle: errorMessage,
          closeAction: () => setModalFeedback(null),
          showButtonModal: true,
          textButton: 'OK',
          buttonAction: () => {
            setModalFeedback(null);
            navigate('/home')
          }
        });
      })
      .finally(() => {
        setShowLoading(false);
      });
  };

  useEffect(() => {
    if (stepAdesaoAeromedica === StepAeromedicaEnum.Termos && !termo) {
      fetchTermo();
    }
    if (stepAdesaoAeromedica === StepAeromedicaEnum.Contrato && !contract) {
      fetchContrato();
    }
  }, [stepAdesaoAeromedica, termo, contract]);

  return (
    <div className="container">
      {showLoading && <LoadingApp showLoading={showLoading} text={textLoading} />}
      {acceptedTerms && showMenu &&
        (
          <div>
            <PageTitle text={"Aeromédica "} />

            <div className="aeromedica-buttons-wrapper">
              <div
                className="aeromedica-description-box"
                style={{
                  ...accessibility.contrastStyle,
                  ...accessibility.contrastBorderAccessibility,
                }}
              >
                <p
                  className="aeromedica-description"
                  style={accessibility.textStyleAccessibility}
                >
                  Aguarde, a equipe do comercial entrará em contato em até dois
                  dias úteis
                </p>
              </div>
              {menu.map((item, idx) => (
                <div className="aeromedica-option-button">
                  <Button
                    key={idx}
                    fullWidth
                    style={{
                      ...accessibility.contrastStyle,
                      ...accessibility.contrastBorderAccessibility,
                    }}
                    sx={sxRefundButton}
                    onClick={() => handleMenuClick(item)}
                  >
                    <Typography
                      style={accessibility.textStyleAccessibility}
                      sx={sxRefundButtonText}
                    >
                      {item.title}
                    </Typography>
                    <FontAwesomeIcon
                      style={accessibility.textStyleAccessibility}
                      color="#383838"
                      size="lg"
                      icon={faChevronRight}
                    />
                  </Button>
                </div>
              ))}
            </div>
          </div>
        )}
      {!showMenu &&
        <div className="container">
          <PageTitle text={
            (stepAdesaoAeromedica === StepAeromedicaEnum.Termos || stepAdesaoAeromedica === StepAeromedicaEnum.Contrato)
              ? "Aceite dos termos"
              : "Aeromédica"
          } />
          {stepAdesaoAeromedica === StepAeromedicaEnum.Banner && (
            <Banner banner={banner || ''} handleContinue={handleContinue} />
          )}
          <>
            {((stepAdesaoAeromedica === StepAeromedicaEnum.Termos || showTerms) && termo) && (
              <TermsAeromedica
                termo={termo}
                accessibility={accessibility}
                justView={justView}
                handleContinue={handleContinue}
                handleBack={!acceptedTerms ? handleBack : handleShowTerms}
              />
            )}
            {((stepAdesaoAeromedica === StepAeromedicaEnum.Contrato || showContract) && contract) && (
              <ContractAeromedica
                contract={contract}
                accessibility={accessibility}
                justView={justView}
                acceptedContract={acceptedContract}
                setAcceptedContract={setAcceptedContract}
                handleContinue={handleContinue}
                handleBack={!acceptedContract ? handleBack : handleShowContract}
              />
            )}
          </>
        </div>
      }
      <ModalConfirmData
        showModal={showEmailModal}
        handleShowModal={handleShowEmailModal}
        handleConfirmData={handleConfirmUserData}
      />
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </div>
  );
};

export default Aeromedica;
